import img_tailwindcss from "../assets/imgHardSkills/Tailwindcss.png";
import img_CSS from "../assets/imgHardSkills/css-3.png";
import img_HTML from "../assets/imgHardSkills/html.png";
import img_JS from "../assets/imgHardSkills/JavaScript.png";
import img_MySQL from "../assets/imgHardSkills/MySQL.png";
import img_NodeJs from "../assets/imgHardSkills/NodeJs.png";
import img_ReactJs from "../assets/imgHardSkills/ReactJs.png";
import img_ESlint from "../assets/imgTool/ESlint.png";
import img_Git from "../assets/imgTool/Git.png";
import img_GitHub from "../assets/imgTool/GitHub.png";
import img_VScode from "../assets/imgTool/VScode.png";
import img_Figma from "../assets/imgTool/Figma.png";
import img_Airtable from "../assets/imgTool/Airtable.png";
import img_Trello from "../assets/imgTool/Trello.png";
import img_autonome from "../assets/imgSoftSkills/autonome.png";
import img_curieux from "../assets/imgSoftSkills/curieux.png";
import img_esprit_equipe from "../assets/imgSoftSkills/espritEquipe.png";
import img_logique from "../assets/imgSoftSkills/logique.png";
import img_ecoute from "../assets/imgSoftSkills/ecoute.png";

const dataSkills = [
  /********** SOFTS SKILLS ***************/

  {
    image: img_esprit_equipe,
    catégorie: "Atout",
    element: "Esprit d'équipe",
  },
  {
    image: img_autonome,
    catégorie: "Atout",
    element: "Autonome",
  },
  {
    image: img_ecoute,
    catégorie: "Atout",
    element: "Sens de l'écoute",
  },
  {
    image: img_logique,
    catégorie: "Atout",
    element: "Logique",
  },
  {
    image: img_curieux,
    catégorie: "Atout",
    element: "Curieux",
  },

  /********** HARDS SKILLS ***************/

  {
    catégorie: "Compétence",
    element: "HTML5",
    image: img_HTML,
  },
  {
    catégorie: "Compétence",
    element: "CSS3",
    image: img_CSS,
  },
  {
    catégorie: "Compétence",
    element: "JavaScript",
    image: img_JS,
  },
  {
    catégorie: "Compétence",
    element: "ReactJs",
    image: img_ReactJs,
  },
  {
    catégorie: "Compétence",
    element: "NodeJs",
    image: img_NodeJs,
  },
  {
    catégorie: "Compétence",
    element: "TailwindCSS",
    image: img_tailwindcss,
  },
  {
    catégorie: "Compétence",
    element: "Mysql",
    image: img_MySQL,
  },

  /********** OUTILS ***************/

  {
    catégorie: "Outil",
    element: "GitHub",
    image: img_GitHub,
  },
  {
    catégorie: "Outil",
    element: "Git",
    image: img_Git,
  },
  {
    catégorie: "Outil",
    element: "ESlint",
    image: img_ESlint,
  },
  {
    catégorie: "Outil",
    element: "Visual studio code",
    image: img_VScode,
  },
  {
    catégorie: "Outil",
    element: "Figma",
    image: img_Figma,
  },
  {
    catégorie: "Outil",
    element: "Trello",
    image: img_Trello,
  },
  {
    catégorie: "Outil",
    element: "Airtable",
    image: img_Airtable,
  },
];

export default dataSkills;
